import { useState } from 'react'
import { useContext } from 'react'

import dayjs from 'dayjs'

import { useUpdateArticleApprovalScheduleApi } from '@/common/api/modules/articleApproval'

import Button from '@/components/view/atoms/button/Button'
import { ButtonColor } from '@/components/view/atoms/button/Button'
import FormLabel from '@/components/view/atoms/form/FormLabel'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

import { ToastMessageContext } from '@/components/container/utils/message/ToastMessageProvider'

interface Props {
  requestId: number
  siteId: number
  scheduledUploadAt: string | null
  onChange: (newSchedule: string | null) => void
  onClickCancel: () => void
}

const ArticleApprovalScheduleEdit = ({
  requestId: reqId,
  siteId,
  scheduledUploadAt,
  onChange,
  onClickCancel
}: Props) => {
  const { addMessage } = useContext(ToastMessageContext)
  const [newSchedule, setNewSchedule] = useState(
    scheduledUploadAt ? dayjs(scheduledUploadAt).format('YYYY-MM-DDTHH:mm') : ''
  )

  const { trigger: updateSchedule, isMutating } = useUpdateArticleApprovalScheduleApi({
    onSuccess: (data) => {
      onChange(data.scheduled_upload_at)
      addMessage({
        type: 'success',
        text: 'アップロード予定日時を更新しました。'
      })
    }
  })

  const handleScheduleUpdate = () => {
    if (!newSchedule) return
    updateSchedule({
      site_id: siteId,
      request_id: reqId,
      // オフセット付き絶対時刻で送信（ブラウザTZ非依存。バックエンドは UTC で保存）
      scheduled_upload_at: dayjs(newSchedule).toISOString()
    })
  }

  return (
    <>
      <ItemAlign gapY={8} direction='vertical'>
        <FormLabel>アップロード予定日時</FormLabel>
        <TextField
          type='datetime-local'
          size={TextBoxSize.MEDIUM}
          value={newSchedule}
          onChange={(e) => setNewSchedule(e.target.value)}
        />
        <ItemAlign gapX={8}>
          <Button color={ButtonColor.SECONDARY} onClick={() => onClickCancel()}>
            キャンセル
          </Button>
          <Button
            color={ButtonColor.PRIMARY}
            disabled={!newSchedule}
            onClick={() => handleScheduleUpdate()}
            loading={isMutating}
          >
            適用
          </Button>
        </ItemAlign>
      </ItemAlign>
    </>
  )
}

export default ArticleApprovalScheduleEdit
